import { baseurl } from '../baseurl';
import { getCookie } from '../../../utils/cookies';



// -----------------------Seguros--------------- 
export const getListaService = (request) => {
  const apiURL = baseurl('seguros');
  
  const parameters = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': getCookie('timeoff-token')
    },
    body: JSON.stringify(request.user)
  };

  return fetch(apiURL, parameters)
    .then(response => {
      return response.json();
    })
    .then(json => {
      return json;
    })
    .catch(error => {
      return error;
    });
};